// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as OrderActions } from '../../duck';
import { actions as AlertActions } from '../../../alert/duck';
import Sale from '../components/Sale';

import type { RootState } from '../../../index';

function mapStateToProps(state: RootState) {
  return {
    isFetchingOrder: state.order.isFetchingOrder,
    order: state.order.order,
    fetchOrderError: state.order.fetchOrderError,
    localValues: state.localValues,
    localeState: state.locale,
    isProgressingOrder: state.order.sale.reserved.isProgressing || state.order.sale.purchased.isProgressing ||
      state.order.sale.received.isProgressing || state.order.sale.deliver.isPostingProgress,
    progressError: state.order.sale.reserved.progressError || state.order.sale.purchased.progressError ||
      state.order.sale.received.error || state.order.sale.deliver.postProgressError,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...OrderActions,
    ...AlertActions,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Sale);



// WEBPACK FOOTER //
// ./src/modules/order/Sale/containers/SaleContainer.jsx